"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Inspector = void 0;
const dht_1 = require("@streamr/dht");
const utils_1 = require("@streamr/utils");
const NetworkRpc_client_1 = require("../../../generated/packages/trackerless-network/protos/NetworkRpc.client");
const TemporaryConnectionRpcRemote_1 = require("../temporary-connection/TemporaryConnectionRpcRemote");
const InspectSession_1 = require("./InspectSession");
const logger = new utils_1.Logger(module);
const DEFAULT_TIMEOUT = 60 * 1000;
class Inspector {
    sessions = new Map();
    streamPartId;
    localPeerDescriptor;
    rpcCommunicator;
    connectionLocker;
    inspectionTimeout;
    openInspectConnection;
    closeInspectConnection;
    constructor(options) {
        this.streamPartId = options.streamPartId;
        this.localPeerDescriptor = options.localPeerDescriptor;
        this.rpcCommunicator = options.rpcCommunicator;
        this.connectionLocker = options.connectionLocker;
        this.inspectionTimeout = options.inspectionTimeout ?? DEFAULT_TIMEOUT;
        this.openInspectConnection = options.openInspectConnection ?? this.defaultOpenInspectConnection;
        this.closeInspectConnection = options.closeInspectConnection ?? this.defaultCloseInspectConnection;
    }
    async defaultOpenInspectConnection(peerDescriptor, lockId) {
        const rpcRemote = new TemporaryConnectionRpcRemote_1.TemporaryConnectionRpcRemote(this.localPeerDescriptor, peerDescriptor, this.rpcCommunicator, NetworkRpc_client_1.TemporaryConnectionRpcClient);
        await rpcRemote.openConnection();
        this.connectionLocker.weakLockConnection((0, dht_1.toNodeId)(peerDescriptor), lockId);
    }
    async defaultCloseInspectConnection(peerDescriptor, lockId) {
        const rpcRemote = new TemporaryConnectionRpcRemote_1.TemporaryConnectionRpcRemote(this.localPeerDescriptor, peerDescriptor, this.rpcCommunicator, NetworkRpc_client_1.TemporaryConnectionRpcClient);
        await rpcRemote.closeConnection();
        this.connectionLocker.weakUnlockConnection((0, dht_1.toNodeId)(peerDescriptor), lockId);
    }
    async inspect(peerDescriptor) {
        const nodeId = (0, dht_1.toNodeId)(peerDescriptor);
        const session = new InspectSession_1.InspectSession({
            inspectedNode: nodeId
        });
        const lockId = `inspector-${this.streamPartId}`;
        this.sessions.set(nodeId, session);
        await this.openInspectConnection(peerDescriptor, lockId);
        let success = false;
        try {
            await (0, utils_1.waitForEvent3)(session, 'done', this.inspectionTimeout);
            success = true;
        }
        catch {
            logger.trace('Inspect session timed out, removing');
        }
        finally {
            await this.closeInspectConnection(peerDescriptor, lockId);
            this.sessions.delete(nodeId);
        }
        return success || session.getInspectedMessageCount() < 1 || session.onlyMarkedByInspectedNode();
    }
    markMessage(sender, messageId) {
        this.sessions.forEach((session) => session.markMessage(sender, messageId));
    }
    isInspected(nodeId) {
        return this.sessions.has(nodeId);
    }
    stop() {
        this.sessions.forEach((session) => {
            session.stop();
        });
        this.sessions.clear();
    }
}
exports.Inspector = Inspector;
//# sourceMappingURL=Inspector.js.map